import React from "react";

const gallery = [
  { id: 1, name: "Jeep Renegade", image: "images/vehicle-2/pic1.jpg", category: "cat-2" },
  { id: 2, name: "Ferarri Enzo", image: "images/vehicle-2/pic2.jpg", category: "cat-1" },
  { id: 3, name: "Mini Cooper", image: "images/vehicle-2/pic3.jpg", category: "cat-3" },
  { id: 4, name: "Rolls Royce Cullinan", image: "images/vehicle-2/pic4.jpg", category: "cat-4" },
  { id: 5, name: "Porsche 911", image: "images/vehicle-2/pic5.jpg", category: "cat-5" },
  { id: 6, name: "Chevrolet Coupe", image: "images/vehicle-2/pic6.jpg", category: "cat-4" },
  { id: 7, name: "Ford White SUV", image: "images/vehicle-2/pic7.jpg", category: "cat-2" },
  { id: 8, name: "Toyota Crew Cab", image: "images/vehicle-2/pic8.jpg", category: "cat-1" },
  { id: 9, name: "Lamborghini", image: "images/vehicle-2/pic9.jpg", category: "cat-3" },
  { id: 10, name: "Audi Sport", image: "images/vehicle-2/pic10.jpg", category: "cat-4" },
  { id: 11, name: "BMW", image: "images/vehicle-2/pic11.jpg", category: "cat-5" },
  { id: 12, name: "White BMW", image: "images/vehicle-2/pic12.jpg", category: "cat-4" }
];

const Gallery = () => {
  return (
    <div className="section-full site-bg-white p-t150 p-b120 twm-portfolio-wrap">
      <div className="container">

        {/* Filter Nav */}
        <div className="filter-navigation-wrap p-b30">
          <ul className="filter-navigation masonry-filter clearfix">
            <li className="active"><span className="btn-inline">All</span></li>
            <li><span className="btn-inline">Luxury</span></li>
            <li><span className="btn-inline">Cars</span></li>
            <li><span className="btn-inline">Sports Cars</span></li>
            <li><span className="btn-inline">Suv</span></li>
          </ul>
        </div>

        {/* Gallery */}
        <ul className="masonry-outer work-grid row clearfix list-unstyled m-b0">

          {gallery.map((item) => (
            <li
              key={item.id}
              className={`masonry-item ${item.category} col-lg-4 col-md-6 m-b30`}
            >
              <div className="twm-gallery-section">

                <div className="elem media">
                  <img src={item.image} alt={item.name} />
                  <span className="icon-view">
                    <i className="feather feather-maximize"></i>
                  </span>
                </div>

                <div className="twm-gallery-info">
                  <h3 className="twm-title">{item.name}</h3>
                </div>

              </div>
            </li>
          ))}

        </ul>

      </div>
    </div>
  );
};

export default Gallery;